'use client';

import { useFeatureFlagEnabled } from 'posthog-js/react';

/**
 * Feature Flag / A/B テスト用 hook。
 * `posthog.useFeatureFlagEnabled()` の薄いラッパー。
 *
 * 段階リリース・kill switch・A/B テスト（Google Optimize 廃止後の空白を埋める）用途で
 * `@monorepo/common` から提供する。
 *
 * @returns フラグが有効なら `true`、無効なら `false`、評価前（読み込み中 / 未init）は `undefined`。
 *          読み込み中とOFFを区別したい場合があるため `undefined` をそのまま返す。
 */
export function useFeatureFlag(flagKey: string): boolean | undefined {
  return useFeatureFlagEnabled(flagKey);
}
